export interface User {
  id: string;
  email: string;
  firstName: string;
  lastName: string;
  phoneNumber?: string;
  username?: string;
  role: UserRole;
  isVerified: boolean;
  authType: "manual" | "phone" | "gmail" | "google"; // ✅ Added "manual" for email/password auth, "google" for backend compatibility
  hasSetPassword?: boolean; // For Google users: false = dummy password, true = real password set
  preferences: UserPreferences;
  createdAt: string;
  updatedAt: string;
  profilePicture?: string;
}

export enum UserRole {
  Customer = "customer",
  Admin = "admin",
  Shopper = "shopper",
  Cargo = "cargo",
}

export interface UserPreferences {
  language: string;
  currency: string;
  notifications: {
    email: boolean;
    sms: boolean;
    push: boolean;
  };
  theme: "light" | "dark";
}

export interface UserProfile {
  id: string;
  email: string;
  firstName: string;
  lastName: string;
  phoneNumber?: string;
  address?: Address;
  preferences: UserPreferences;
}

export interface Address {
  id: string;
  street: string;
  city: string;
  state: string;
  zipCode: string;
  country: string;
  isDefault: boolean;
}

export interface UserInfo {
  id: string;
  email: string;
  firstName: string;
  lastName: string;
  phoneNumber?: string;
  profilePicture?: string;
  preferences: UserPreferences;
}

export type ProfileSection =
  | "personal"
  | "payment"
  | "orders"
  | "wishlist"
  | "address"
  | "changePassword"
  | "support"
  | "referral";

export interface WishlistItem {
  id: string;
  title: string;
  image: string;
  price: number;
  retailer: string;
}

export interface Ticket {
  id: string;
  subject: string;
  description: string;
  status: "open" | "in-progress" | "resolved" | "closed";
  priority: "low" | "medium" | "high";
  createdAt: string;
  lastUpdated: string;
}

export interface OrderCard {
  icon: React.ReactNode;
  label: string;
  count: number;
}

export interface PaymentMethod {
  id: string;
  type: string;
  last4: string;
  expiry: string;
  isDefault: boolean;
}
